export const prodThirdPartyToOrgId = {
  whistleout: '240',
  canstar: '237',
  finder: '238',
  credit_simple: '634', // Credit Simple
  myco: '369', // MyConnect
  allianz: '635', // Allianz
  eg: '636', // EG
  drakes: '637', // Drakes
  catalinavillage: '638', // Catalina Village
  'money.com.au': '1957', // Money.com
  choiceenergy: '1990', // Choice Energy
  onebigswitchsolar: '270', // One Big Switch — Solar
  msgbrokersale: '2392', // MSG Broker Sale
};

export const nonProdThirdPartyToOrgId = {
  whistleout: '178',
  canstar: '237',
  finder: '177',
  credit_simple: '634', // Credit Simple
  myco: '369', // MyConnect
  allianz: '635', // Allianz
  eg: '636', // EG
  drakes: '637', // Drakes
  catalinavillage: '638', // Catalina Village
  'money.com.au': '1957', // Money.com
  choiceenergy: '1990', // Choice Energy
  onebigswitchsolar: '270', // One Big Switch — Solar
  msgbrokersale: '2392', // MSG Broker Sale
};
